(function ($) {
  window.DGS.OnLoad.getInstance().register(function () {
    $('.lattice-spot').each(function () {
      var $spot = $(this);
      window.DGS.EqualHeight.getInstance().register($('.lattice-spot-item', $spot), true);
    });
  });
})(jQuery);